// Module
var code = "<i ref=\"icon\" aria-hidden=\"true\"></i>";
// Exports
module.exports = code;